<template>
    <mds-form size="small">
        <mds-fieldset hidden-legend variation="checkbox-group" size="small">
            <mds-checkbox e2e="reinvest-capital" size="small" v-model="reinvestCapitalGains">{{
                this.getUILabel("transactions_reinvestCapitalGains")
            }}</mds-checkbox>
            <mds-checkbox e2e="reinvest-dividend" size="small" v-model="reinvestDividends">{{
                this.getUILabel("transactions_reinvestDividends")
            }}</mds-checkbox>
        </mds-fieldset>
    </mds-form>
</template>

<script>
import HypoVueBaseMixin from "hypo-vue-base-mixin";
import MwcVueHelperMixin from "mwc-vue-component-helper";
import MdsForm from "@mds/form";
import MdsFieldset from "@mds/fieldset";
import MdsCheckbox from "@mds/checkbox";
import * as types from "../store/mutation-types";

export default {
    name: "reinvestment-content",
    mixins: [HypoVueBaseMixin, MwcVueHelperMixin],
    components: {
        MdsForm,
        MdsFieldset,
        MdsCheckbox
    },
    computed: {
        reinvestCapitalGains: {
            get() {
                return this.$store.state.reinvestment.reinvestCapitalGains;
            },
            set(value) {
                this.$store.commit(`reinvestment/${types.SET_REINVEST_CAPITAL_GAINS}`, value);
            }
        },
        reinvestDividends: {
            get() {
                return this.$store.state.reinvestment.reinvestDividends;
            },
            set(value) {
                this.$store.commit(`reinvestment/${types.SET_REINVEST_DIVIDENDS}`, value);
            }
        }
    }
};
</script>
